import React, { useState } from 'react';
import { createResidente, updateResidente } from '../api';

export default function ResidenteForm({ residente, onSuccess, onCancel }) {
  const [form, setForm] = useState({
    cedula: residente?.cedula || '',
    nombre_completo: residente?.nombre_completo || '',
    celular: residente?.celular || '',
    apartamento: residente?.apartamento || '',
    piso: residente?.piso || ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const isEditing = !!residente;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isEditing) {
        await updateResidente(residente.id, form);
      } else {
        const data = await createResidente(form);
        setResult(data);
      }
      onSuccess();
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  if (result && !isEditing) {
    return (
      <div style={{ textAlign: 'center', padding: '24px 0' }}>
        <div className="empty-icon" style={{ fontSize: '3.5rem' }}>✅</div>
        <h3 style={{ margin: '8px 0' }}>Residente creado exitosamente</h3>
        <p style={{ fontWeight: 600, fontSize: '1.1rem' }}>{result.nombre_completo}</p>
        <p className="text-sm">Apto: {result.apartamento} — Piso: {result.piso}</p>
        <div className="card" style={{ margin: '16px 0', background: 'var(--primary-light)', borderColor: 'var(--primary)' }}>
          <p className="text-sm" style={{ textAlign: 'center' }}>
            👤 <strong>Usuario:</strong> {result.cedula}<br />
            🔑 <strong>Contraseña:</strong> {result.password_default}
          </p>
        </div>
        <button className="btn btn-primary btn-full" onClick={onCancel}>Cerrar</button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      {error && <div className="alert alert-error">⚠️ {error}</div>}
      <div className="form-group">
        <label>Cédula</label>
        <input name="cedula" value={form.cedula} onChange={handleChange}
          placeholder="Número de cédula" disabled={isEditing} required />
      </div>
      <div className="form-group">
        <label>Nombre completo</label>
        <input name="nombre_completo" value={form.nombre_completo} onChange={handleChange}
          placeholder="Nombre completo" required />
      </div>
      <div className="form-group">
        <label>Número de celular</label>
        <input name="celular" value={form.celular} onChange={handleChange}
          placeholder="Número de celular" required />
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Apartamento</label>
          <input name="apartamento" value={form.apartamento} onChange={handleChange}
            placeholder="N° apartamento" required />
        </div>
        <div className="form-group">
          <label>Piso</label>
          <input name="piso" value={form.piso} onChange={handleChange}
            placeholder="Piso" required />
        </div>
      </div>
      <div className="btn-row mt-16">
        <button type="button" className="btn btn-outline" onClick={onCancel}>Cancelar</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Guardando...' : isEditing ? 'Actualizar' : 'Registrar Residente'}
        </button>
      </div>
    </form>
  );
}